import { FormEvent, useState } from "react";
import styles from "./Filters.module.css";
import SearchIcon from "img/Search-icon.svg";

interface Props {
	onChange: (v: string) => void;
}
const SearchBar = ({ onChange }: Props) => {
	const [string, setString] = useState("");
	const submit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onChange(string);
	};

	return (
		<form className={styles.searchFilter} onSubmit={(e) => submit(e)}>
			<input
				data-testid="input-field"
				type="text"
				placeholder="SEARCH"
				value={string}
				onChange={(e) => setString(e.target.value)}
			/>
			<button type="submit">
				<img src={SearchIcon} alt="Search" />
			</button>
		</form>
	);
};

export default SearchBar;
